/**
 * Whether this device has met the game before.
 *
 * A display preference like layout and locale, and stored the same way: per
 * device in localStorage, never on the wire, never anybody's business but this
 * browser's. Two people on one machine share it, which is the right answer —
 * the second of them has watched the first play.
 */
export const INTRO_KEY = 'robotrons:seen-intro';

export function hasSeenIntro() {
  try {
    if (localStorage.getItem(INTRO_KEY) === 'true') return true;
    // Nobody who has already named themselves is new here. Without this, the
    // deploy that added the welcome panel would greet every existing player
    // as a first-time visitor exactly once — true of nothing and nobody.
    return (localStorage.getItem('nickname') ?? '').trim() !== '';
  } catch (e) {
    // Private mode / blocked site data. Offering the tutorial to someone who
    // has seen it is the cheaper of the two mistakes available here.
    return false;
  }
}

export function markIntroSeen() {
  try {
    localStorage.setItem(INTRO_KEY, 'true');
  } catch (e) {
    // The panel still closes; it just comes back on the next visit.
  }
}
